import storage from '@/utils/storage'

// Not for production, only this logic only for Expo 2026
const PENDING_ACTION_KEY = 'omPendingCheckoutAction'
const COMPLETION_SOURCE_KEY = 'omCheckoutCompletionSource'
const PENDING_ACTION_TTL_MS = 60 * 1000

export const CHECKOUT_PENDING_ACTIONS = {
	PAY: 'pay',
	CLOSE: 'close'
}

export const CHECKOUT_COMPLETION_SOURCES = {
	SELF: 'self',
	POS_STAFF: 'posStaff'
}

const parseStorageRecord = key => {
	const rawValue = storage.getStorage(key)

	if (!rawValue) return null

	try {
		return JSON.parse(rawValue)
	} catch (e) {
		storage.removeFromStorage(key)

		return null
	}
}

const setStorageRecord = (key, value) => {
	storage.setStorage(key, JSON.stringify(value))
}

const isExpiredRecord = (record, ttlMs) => {
	if (!record?.createdAt) return true

	return Date.now() - Number(record.createdAt) > ttlMs
}

const normalizeEmployeeName = employeeName => {
	if (typeof employeeName !== 'string') return ''

	const normalizedName = employeeName.trim()

	if (!normalizedName) return ''
	if (normalizedName.toLowerCase() === 'server') return 'Server'

	return normalizedName
}

const getLatestEmployeeNameFromItems = items => {
	if (!Array.isArray(items) || !items.length) return ''

	const sortedItems = [...items].sort((leftItem, rightItem) => {
		return (
			new Date(rightItem?.creationTime).getTime() -
			new Date(leftItem?.creationTime).getTime()
		)
	})

	for (const item of sortedItems) {
		const employeeName = normalizeEmployeeName(item?.tab?.employeeName)

		if (employeeName) return employeeName
	}

	return ''
}

export const markPendingCheckoutAction = (cartId, action) => {
	if (!cartId || !action) return

	setStorageRecord(PENDING_ACTION_KEY, {
		cartId,
		action,
		createdAt: Date.now()
	})
}

export const getPendingCheckoutAction = cartId => {
	const pendingAction = parseStorageRecord(PENDING_ACTION_KEY)

	if (!pendingAction || isExpiredRecord(pendingAction, PENDING_ACTION_TTL_MS)) {
		storage.removeFromStorage(PENDING_ACTION_KEY)

		return null
	}

	if (cartId && pendingAction.cartId !== cartId) return null

	return pendingAction
}

export const clearPendingCheckoutAction = cartId => {
	const pendingAction = parseStorageRecord(PENDING_ACTION_KEY)

	if (!pendingAction) return
	if (cartId && pendingAction.cartId !== cartId) return

	storage.removeFromStorage(PENDING_ACTION_KEY)
}

export const setCheckoutCompletionSource = (cartId, source) => {
	if (!cartId || !source) return

	setStorageRecord(COMPLETION_SOURCE_KEY, {
		cartId,
		source,
		createdAt: Date.now()
	})
}

export const getCheckoutCompletionSource = cartId => {
	const completionSource = parseStorageRecord(COMPLETION_SOURCE_KEY)

	if (!completionSource) return null
	if (cartId && completionSource.cartId !== cartId) return null

	return completionSource
}

export const clearCheckoutCompletionSource = cartId => {
	const completionSource = parseStorageRecord(COMPLETION_SOURCE_KEY)

	if (!completionSource) return
	if (cartId && completionSource.cartId !== cartId) return

	storage.removeFromStorage(COMPLETION_SOURCE_KEY)
}

export const clearCheckoutTracking = cartId => {
	clearPendingCheckoutAction(cartId)
	clearCheckoutCompletionSource(cartId)
}

export const syncCheckoutTracking = currentCartId => {
	const pendingAction = parseStorageRecord(PENDING_ACTION_KEY)
	const completionSource = parseStorageRecord(COMPLETION_SOURCE_KEY)

	if (
		!currentCartId ||
		(pendingAction &&
			(isExpiredRecord(pendingAction, PENDING_ACTION_TTL_MS) ||
				pendingAction.cartId !== currentCartId))
	) {
		storage.removeFromStorage(PENDING_ACTION_KEY)
	}

	if (
		!currentCartId ||
		(completionSource && completionSource.cartId !== currentCartId)
	) {
		storage.removeFromStorage(COMPLETION_SOURCE_KEY)
	}
}

export const resolveLatestEmployeeName = (fullItemsList, cartItems) => {
	return (
		getLatestEmployeeNameFromItems(fullItemsList) ||
		getLatestEmployeeNameFromItems(cartItems) ||
		'Server'
	)
}
